import LegalLayout from '../components/LegalLayout';

const SECTIONS = [
  {
    id: 'overview',
    heading: 'Overview',
    body: (
      <p>
        This Privacy Policy explains what information FreeMansLive collects when you use the Site, why we
        collect it, and how it's handled. Using the Site means you're okay with the practices described here.
      </p>
    ),
  },
  {
    id: 'collect',
    heading: 'Information We Collect',
    body: (
      <>
        <p>
          <b>From Kick, when you sign in:</b> your Kick username, user ID, and avatar image, via Kick's
          official OAuth login. We never see or store your Kick password.
        </p>
        <p>
          <b>From your Kick chat activity:</b> your username and messages sent in the FreeMansLive chatroom, so
          the bot can track watch-time points, mini-game commands, predictions, and rain participation.
        </p>
        <p>
          <b>Information you provide directly:</b> anything you add in your profile settings — for example a
          BetDice/Unbox.gg/Rain.gg username, or a crypto wallet address — used only to fulfill prizes you've
          won or redeemed.
        </p>
        <p>
          <b>Site activity:</b> your points balance, transaction history (games played, items redeemed, raffle
          tickets, TTS messages sent) and standard server logs (IP address, timestamps) for security and abuse
          prevention.
        </p>
      </>
    ),
  },
  {
    id: 'use',
    heading: 'How We Use It',
    body: (
      <ul className="list-disc pl-5 flex flex-col gap-1.5">
        <li>to operate your account, points balance, and the Site's features;</li>
        <li>to fulfill Store, Case, and Raffle prizes you've won or redeemed;</li>
        <li>to read out Text-to-Speech messages you've submitted, on stream;</li>
        <li>to detect and prevent cheating, multi-accounting, and abuse;</li>
        <li>to keep the Site secure and diagnose technical issues.</li>
      </ul>
    ),
  },
  {
    id: 'sharing',
    heading: 'Sharing',
    body: (
      <p>
        We don't sell your information. We don't share it with third parties except: (a) service providers we
        use to run the Site (such as our hosting provider and the text-to-speech provider used for the TTS
        feature — only the message text you submit is sent to it), or (b) when required by law.
      </p>
    ),
  },
  {
    id: 'retention',
    heading: 'Data Retention',
    body: (
      <p>
        We keep account and activity data for as long as your account is active, or as needed to resolve
        disputes and enforce these policies. You can ask us to delete your account data at any time — see
        Contact below.
      </p>
    ),
  },
  {
    id: 'cookies',
    heading: 'Cookies & Sessions',
    body: (
      <p>
        The Site uses a session cookie to keep you signed in after linking your Kick account. We don't use
        third-party advertising or tracking cookies.
      </p>
    ),
  },
  {
    id: 'children',
    heading: "Children's Privacy",
    body: (
      <p>
        The Site isn't directed at children under 13, and we don't knowingly collect information from them. If
        you believe a child has used the Site, contact us and we'll remove the associated data.
      </p>
    ),
  },
  {
    id: 'rights',
    heading: 'Your Choices',
    body: (
      <p>
        You can update or remove the account/wallet details in your profile settings at any time. To request a
        copy of your data or full account deletion, contact us using the email below.
      </p>
    ),
  },
  {
    id: 'changes',
    heading: 'Changes to This Policy',
    body: (
      <p>
        We may update this Privacy Policy from time to time. Continued use of the Site after changes are posted
        means you accept the updated policy.
      </p>
    ),
  },
  {
    id: 'contact',
    heading: 'Contact',
    body: (
      <p>
        Questions, data requests, or deletion requests can be sent to{' '}
        <a href="mailto:Freemanthe3rd@gmail.com" className="text-[#ff544a] hover:underline font-bold">
          Freemanthe3rd@gmail.com
        </a>
        .
      </p>
    ),
  },
];

export default function Privacy() {
  return (
    <LegalLayout
      title="Privacy Policy"
      updated="August 11, 2026"
      intro="What we collect when you use FreeMansLive, why, and how to reach us about it."
      sections={SECTIONS}
    />
  );
}
